module.exports = __webpack_public_path__ + "img/logo.eba6d1dd.svg";